import { invalidChangeGiftType } from 'constants/index';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useValidConditionChangeGift = (quantity, quantityUserWantChange = 1, pointOfGift) => {
  const [valid, setValid] = useState(true);
  const [type, setType] = useState(invalidChangeGiftType.LACK_POINT);
  const LoyaltyAccountInfo = useSelector((state) => state.LoyaltyAccountInfoReducer);

  const point = LoyaltyAccountInfo.profilebyc.obj.memberLoyaltyInfo?.coin || 0;

  useEffect(() => {
    if (point < pointOfGift * quantityUserWantChange) {
      setValid(false);
      setType(invalidChangeGiftType.LACK_POINT);
    } else if (quantity < quantityUserWantChange) {
      setValid(false);
      setType(invalidChangeGiftType.LACK_QUANTITY);
    } else {
      setValid(true);
    }
  }, [quantity, quantityUserWantChange, pointOfGift, point]);

  return { valid, invalidType: type };
};

export default useValidConditionChangeGift;
